// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

	production: false,
	url_sosem:					'http://10.0.10.87:8000/api',
	url_patrimonio:				'http://190.108.89.83:9090',
	url:						'https://sipacgeragri.regioncusco.gob.pe/api', // personal
	url_reportes:				'https://sipacgeragri.regioncusco.gob.pe/api', // reportes
	url_activos_ti:				'http://localhost:8085', // ti activos
	url_system:					'https://sipacgeragri.regioncusco.gob.pe/api',
	apiRegionUrl:				'http://localhost:8089/',
	url_remuneraciones:			'http://localhost:8090',
	urlFrontEnd:				'http://localhost:4200',
	tema:						'#0F0F0F'
	// Conexión en desuso
	/* firebaseConfig: {
		apiKey: "AIzaSyAhskU_TfAaqHOK9I-mGIzFsuhi5L4eQ4Q",
		authDomain: "personal-region.firebaseapp.com",
		databaseURL: "https://personal-region.firebaseio.com",
		projectId: "personal-region",
		storageBucket: "personal-region.appspot.com",
		messagingSenderId: "642342017148",
		appId: "1:642342017148:web:4facd89964819bbec091f9"
	} */

};

